// Libs
import { Typography } from "@mui/material";
import type { ReactNode } from "react";

const CardTitle = ({ children }: { children: ReactNode | ReactNode[] }): JSX.Element => {
    return <Typography variant="h3">{children}</Typography>;
};

export { CardTitle };
